export default __webpack_public_path__ + "static/final-f35832c550223efc69b1f2cf1835e1c3.mp4";